import React from 'react';
import { createRoot } from 'react-dom/client';
import TournamentPage from '../components/tournaments/TournamentPage.jsx';
import TournamentsLayout from '../components/tournaments/TournamentsLayout.jsx';

const params = new URLSearchParams(window.location.search);
const id = params.get('id');

const root = createRoot(document.getElementById('root'));
root.render(
  <TournamentsLayout>
    <TournamentPage
      id={id}
      onBack={() => {
        window.location.href = '/';
      }}
      onAdmin={() => {
        window.location.href = `/admin.html?id=${id}`;
      }}
    />
  </TournamentsLayout>
);
